"use strict";
exports.__esModule = true;
exports.openIntercomChat = void 0;
// @ts-ignore
var react_intercom_1 = require("react-intercom");
function openIntercomChat() {
    if (!react_intercom_1.IntercomAPI) {
        console.log('Intercom is not active!');
        return;
    }
    (0, react_intercom_1.IntercomAPI)('show');
}
exports.openIntercomChat = openIntercomChat;
